import { defineMessages } from 'react-intl';

type MessageKeys = 'createConfluencePageFollowUp';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		createConfluencePageFollowUp: {
			id: 'rovo-chat.store-follow-up.create-confluence-page',
			defaultMessage: 'Create a Confluence page from this response',
			description:
				'Text for a follow-up suggestion button shown after conversational AI responses in Rovo Chat. Clicking it prompts the AI to create a Confluence page from the conversation content.',
		},
	});

export default message;
